import React, { useState, useEffect } from "react";
import _ from "lodash";
import Select from "react-select";
import { getTerritoryCountries } from "../countries/Axios";
import { getTerritoryRegions } from "./Axios";

const RegionsSelect = ({ uniqueId, value, handleChange }) => {
  const [regions, setRegions] = useState([]);
  const [countryId, setCountryId] = useState(null);


  // fot Chile Default country
  useEffect(() => {
    getTerritoryCountries(response => {
      const chile = response.data.find(country => country.name === "Chile");
      if (chile) {
        setCountryId(chile.id);
      }
    });
  }, []);

  useEffect(() => {
    if (countryId) {
      getRegions(countryId);
    }
  }, [countryId]);

  const getRegions = countryId => {
    getTerritoryRegions(countryId, response => {
      const newRegions = _.map(response.data, region => ({
        value: region.id,
        label: region.name,
      }));
      setRegions(newRegions);

      if (!value.value && newRegions.length > 0) {
        handleChange(newRegions[0], "region");
      }
    });
  };

  return (
    <Select
      inputId={`${uniqueId}`}
      onChange={e => handleChange(e, "region")}
      options={regions}
      placeholder="Seleccione una opción"
      value={value.value ? value : null}
      isDisabled={!countryId}
    />
  );
};

export default RegionsSelect;
